module.exports = __webpack_public_path__ + "img/sign1.1641520899224.png";